import { Button } from '@mui/material';
import React, { useState } from 'react';
import AuxDataApi from '../../api/AuxDataApi';
import { handleUnauthorizedResponse } from '../../api/http';
import { AuthData } from '../../context/auth';
import { withAuxDataContext } from '../../context/auxData';
import { ErrorData } from '../../context/ErrorProvider';
import { PRIMARY_BUTTON_STYLE } from '../../data/constants';
import { AuxDataSetCreateRequest, AuxDataUITypes } from '../../types/auxData';
import { errorToast, successToast } from '../Toast';
import AuxDataModal, { getKeyErrors } from './AuxDataModal';

interface Props {
	authData: AuthData;
	errorData: ErrorData;
	entityLocator: string;
	onConfirmCallback: () => Promise<void>;
}

const AuxDataCreateModalTrigger = (props: Props) => {
	const { authData, errorData, entityLocator, onConfirmCallback } = props;
	const [isOpen, setIsOpen] = useState(false);
	const close = () => setIsOpen(false);
	const open = () => setIsOpen(true);
	const { authorizationToken } = authData.auth;

	const handleAddAuxData = async (key: string, value: string) => {
		const params: AuxDataSetCreateRequest = {
			auxData: [
				{
					key,
					value,
					uiType: AuxDataUITypes.normal,
				},
			],
		};

		try {
			const keyErrors = getKeyErrors(key);

			if (!keyErrors.isValid) {
				errorToast(keyErrors.message);

				return false;
			}

			let keyAlreadyExists = true;
			try {
				await AuxDataApi.getAuxData(authorizationToken, entityLocator, key);
			} catch (error) {
				if (error?.response?.status === 404) {
					// 404 is the not found status
					keyAlreadyExists = false;
				} else {
					errorData.handleErrorResponse(error, null);

					return false;
				}
			}

			if (!keyAlreadyExists) {
				await AuxDataApi.createAuxData(
					authorizationToken,
					params,
					entityLocator,
				);
				await onConfirmCallback();
				successToast('Aux data created');

				return true;
			} else {
				errorToast('Key already exists');
				return false;
			}
		} catch (error) {
			errorData.handleErrorResponse(error, 'Failed to create aux data');
			await handleUnauthorizedResponse(error, authData);

			return false;
		}
	};

	return (
		<>
			<Button onClick={open} style={PRIMARY_BUTTON_STYLE}>
				Add Aux Data
			</Button>
			<AuxDataModal
				close={close}
				isOpen={isOpen}
				title={'Add Aux Data'}
				entityLocator={entityLocator}
				handleConfirm={handleAddAuxData}
			/>
		</>
	);
};

export default withAuxDataContext<Props>(AuxDataCreateModalTrigger);
